import React from "react";
import BannerSection from "./First-Fold";
import SliderSection from "./Slider1-Section";
import SliderSection2 from "./Slider2-Section";
import AboutUsSection from "./AboutUs-Section";
import HistorySection from "./History-Section";
import ProductSection from "./Product-Section";
import DistributionSection from "./Distribution-Section";
import WarehouseSection from "./Warehouse-Section";
import InterstateSection from "./Interstate-Section";
import ContactSection from "./Contact-Section";
export default class HomePage extends React.Component {
  render() {
    return (
      <div className="HomePage-Wrapper">
        <BannerSection />
        <SliderSection />
        <AboutUsSection />
        <SliderSection2 />
        <HistorySection />
        <ProductSection />
        <DistributionSection />
        <WarehouseSection />
        <InterstateSection />
        <ContactSection />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/index.js